import React, {useState} from 'react';
import Header from '../componentes/Header';
import AnimacionPagina from '../componentes/AnimacionPagina';
import { motion, useScroll } from 'framer-motion';
import { Link, useNavigate } from 'react-router';
import { Helmet } from 'react-helmet';

import SectionProductos from '../elementos/SectionProductos';
import ContainerProductos from '../elementos/ContaninerProductos';
import ProductoContainer from '../elementos/ProductoContainer';
import BtnVolverAnim from '../elementos/BtnVolverAnim';
import WhatsAppShareButton from '../componentes/WhatsAppShareButton';
import ModalImagenExpandida from '../componentes/ModalImagenExpandida';
import ToldosWhatsAppContact from '../componentes/ToldosWhastsAppContact';
import Footer from '../componentes/Footer';

import imgToldoVertical from '../assets/img/toldoCaidaVertical.jpg'
import imgPiezasTolods from '../assets/img/piezasToldos.jpg'

const InsumosPersianasToldos = () => {
    const navigate = useNavigate();
    const [imagenExpandida, setImagenExpandida] = useState(null);
    return ( 
        <>
        <Helmet>
            <title>Insumos para persianas y toldos | Hi Blinds</title>
            <meta name="description" content="Insumos para armar persianas, toldos, cortineros." />
            <meta property="og:title" content="Insumos para persianas y toldos | Hi Blinds" />
            <meta property="og:description" content="Todo lo necesario para tu negocio de instalación de persinas, toldos y cortineros." />
            <meta property="og:url" content="https://hiblindsmx.com/insumos-para-persianas-y-toldos" />
        </Helmet>
            <Header />
            <AnimacionPagina>
                <SectionProductos>
                    <h1>Insumos para Persianas y Toldos</h1>
                <ContainerProductos >
                    
                        <motion.div 
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.4, delay: 0.1 }}
                        style={{display: 'flex', flexDirection: 'row', gap: '40px', flexWrap: 'wrap', justifyContent:'center'}}
                        >
                            <ProductoContainer
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.8 }}
                            style={{minWidth: '300px', minHeight: ''}}
                            >
                                <img
                                loading='lazy' 
                                src={imgToldoVertical}
                                alt={`Toldo caida vertical`}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setImagenExpandida(imgToldoVertical);
                                  }}
                                style={{minWidth: '250px'}}
                                 />
                                <h2 style={{textAlign: 'center'}}>Toldo caida vertical</h2>
                                <b style={{textAlign: 'center'}}>Más información por WhatsApp</b>
                            </ProductoContainer>
                            <ProductoContainer
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.8 }}
                            style={{minWidth: '300px', minHeight: ''}}
                            >
                                <img
                                loading='lazy' 
                                src={imgPiezasTolods}
                                alt={`Piezas Toldos`}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setImagenExpandida(imgPiezasTolods);
                                  }}
                                style={{minWidth: '250px'}}
                                 />
                                <h2 style={{textAlign: 'center'}}>Todo para armados</h2>
                                <b style={{textAlign: 'center'}}>Más información por WhatsApp</b>
                            </ProductoContainer>
                        </motion.div>
                </ContainerProductos>
                <ToldosWhatsAppContact 
                    phoneNumber="524773059542" 
                    defaultMessage="Quiero saber sobre los insumos para armar persinas, toldos y cortineros" 
                    />
                    <BtnVolverAnim Ref='/' />
                    <WhatsAppShareButton message="¡INSUMOS PARA ARMAR PERSINAS, TOLDOS, CORTINEROS!" />
                </SectionProductos>
                <Footer />
            </AnimacionPagina>
            <ModalImagenExpandida
                imagen={imagenExpandida}
                onClose={() => setImagenExpandida(null)}
              />
        </>
     );
}

export default InsumosPersianasToldos;